// ----------------------
// <auto-generated>
// Generated by PermissionsGenerator.
// </auto-generated>
// ----------------------

export class AdministrationPermissions {
    static _ = 'Administration';

    static User = class {
        static _ = 'Administration.User';

        static viewAll = 'Administration.User.ViewAll';
        static viewOwn = 'Administration.User.ViewOwn';
        static editAll = 'Administration.User.EditAll';
        static editOwn = 'Administration.User.EditOwn';
        static create = 'Administration.User.Create';
    };

    static Role = class {
        static _ = 'Administration.Role';

        static view = 'Administration.Role.View';
        static edit = 'Administration.Role.Edit';
        static create = 'Administration.Role.Create';
    };

    static Organization = class {
        static _ = 'Administration.Organization';

        static viewAll = 'Administration.Organization.ViewAll';
        static viewOwn = 'Administration.Organization.ViewOwn';
        static editAll = 'Administration.Organization.EditAll';
        static editOwn = 'Administration.Organization.EditOwn';
        static create = 'Administration.Organization.Create';
    };

    static Settings = class {
        static _ = 'Administration.Settings';

        static view = 'Administration.Settings.View';
        static edit = 'Administration.Settings.Edit';
    };

}

export class NotificationPermissions {
    static _ = 'Notification';

    static View = class {
        static _ = 'Notification.View';

        static list = 'Notification.View.List';
    };

    static Action = class {
        static _ = 'Notification.Action';

        static create = 'Notification.Action.Create';
        static edit = 'Notification.Action.Edit';
    };

}

export class ReportingPermissions {
    static _ = 'Reporting';

    static View = class {
        static _ = 'Reporting.View';

        static cargoReport = 'Reporting.View.CargoReport';
        static cargoManipulationsReport = 'Reporting.View.CargoManipulationsReport';
        static vesselReport = 'Reporting.View.VesselReport';
        static parkingAndPermitReport = 'Reporting.View.ParkingAndPermitReport';
        static dangerousGoodsReport = 'Reporting.View.DangerousGoodsReport';
        static stockReport = 'Reporting.View.StockReport';
    };

}

export class GeneralCargoServiceRequestPermissions {
    static _ = 'GeneralCargoServiceRequest';

    static View = class {
        static _ = 'GeneralCargoServiceRequest.View';

        static all = 'GeneralCargoServiceRequest.View.All';
        static own = 'GeneralCargoServiceRequest.View.Own';
    };

    static Action = class {
        static _ = 'GeneralCargoServiceRequest.Action';

        static send = 'GeneralCargoServiceRequest.Action.Send';
        static cancel = 'GeneralCargoServiceRequest.Action.Cancel';
        static search = 'GeneralCargoServiceRequest.Action.Search';
        static create = 'GeneralCargoServiceRequest.Action.Create';
        static edit = 'GeneralCargoServiceRequest.Action.Edit';
        static decline = 'GeneralCargoServiceRequest.Action.Decline';
        static accept = 'GeneralCargoServiceRequest.Action.Accept';
        static coordinatorAccept = 'GeneralCargoServiceRequest.Action.CoordinatorAccept';
        static complete = 'GeneralCargoServiceRequest.Action.Complete';
        static addAttachment = 'GeneralCargoServiceRequest.Action.AddAttachment';
    };

}

export class LiquidBulkServiceRequestPermissions {
    static _ = 'LiquidBulkServiceRequest';

    static View = class {
        static _ = 'LiquidBulkServiceRequest.View';

        static all = 'LiquidBulkServiceRequest.View.All';
        static own = 'LiquidBulkServiceRequest.View.Own';
    };

    static Action = class {
        static _ = 'LiquidBulkServiceRequest.Action';

        static send = 'LiquidBulkServiceRequest.Action.Send';
        static cancel = 'LiquidBulkServiceRequest.Action.Cancel';
        static search = 'LiquidBulkServiceRequest.Action.Search';
        static create = 'LiquidBulkServiceRequest.Action.Create';
        static edit = 'LiquidBulkServiceRequest.Action.Edit';
        static decline = 'LiquidBulkServiceRequest.Action.Decline';
        static accept = 'LiquidBulkServiceRequest.Action.Accept';
        static coordinatorAccept = 'LiquidBulkServiceRequest.Action.CoordinatorAccept';
        static complete = 'LiquidBulkServiceRequest.Action.Complete';
        static addAttachment = 'LiquidBulkServiceRequest.Action.AddAttachment';
    };

}

export class GeneralCargoStockRecordPermissions {
    static _ = 'GeneralCargoStockRecord';

    static View = class {
        static _ = 'GeneralCargoStockRecord.View';

        static all = 'GeneralCargoStockRecord.View.All';
        static own = 'GeneralCargoStockRecord.View.Own';
        static warehouseDocuments = 'GeneralCargoStockRecord.View.WarehouseDocuments';
    };

    static Action = class {
        static _ = 'GeneralCargoStockRecord.Action';

        static cancel = 'GeneralCargoStockRecord.Action.Cancel';
        static search = 'GeneralCargoStockRecord.Action.Search';
        static create = 'GeneralCargoStockRecord.Action.Create';
        static ddpRealQuantity = 'GeneralCargoStockRecord.Action.DdpRealQuantity';
        static serviceRequestChangeOwnership = 'GeneralCargoStockRecord.Action.ServiceRequestChangeOwnership';
        static ddpOrigin = 'GeneralCargoStockRecord.Action.DdpOrigin';
        static ddpDestruction = 'GeneralCargoStockRecord.Action.DdpDestruction';
        static ddpWarehouse = 'GeneralCargoStockRecord.Action.DdpWarehouse';
        static ddpAddQuantity = 'GeneralCargoStockRecord.Action.DdpAddQuantity';
        static ddpRemoveQuantity = 'GeneralCargoStockRecord.Action.DdpRemoveQuantity';
        static universalDdp = 'GeneralCargoStockRecord.Action.UniversalDdp';
        static ddpCustoms = 'GeneralCargoStockRecord.Action.DdpCustoms';
        static ddpChangeUnloading = 'GeneralCargoStockRecord.Action.DdpChangeUnloading';
        static createExitServiceRequest = 'GeneralCargoStockRecord.Action.CreateExitServiceRequest';
    };

}

export class LiquidBulkStockRecordPermissions {
    static _ = 'LiquidBulkStockRecord';

    static View = class {
        static _ = 'LiquidBulkStockRecord.View';

        static all = 'LiquidBulkStockRecord.View.All';
        static own = 'LiquidBulkStockRecord.View.Own';
        static warehouseDocuments = 'LiquidBulkStockRecord.View.WarehouseDocuments';
    };

    static Action = class {
        static _ = 'LiquidBulkStockRecord.Action';

        static cancel = 'LiquidBulkStockRecord.Action.Cancel';
        static search = 'LiquidBulkStockRecord.Action.Search';
        static create = 'LiquidBulkStockRecord.Action.Create';
        static ddpRealQuantity = 'LiquidBulkStockRecord.Action.DdpRealQuantity';
        static serviceRequestChangeOwnership = 'LiquidBulkStockRecord.Action.ServiceRequestChangeOwnership';
        static ddpOrigin = 'LiquidBulkStockRecord.Action.DdpOrigin';
        static ddpDestruction = 'LiquidBulkStockRecord.Action.DdpDestruction';
        static ddpWarehouse = 'LiquidBulkStockRecord.Action.DdpWarehouse';
        static ddpAddQuantity = 'LiquidBulkStockRecord.Action.DdpAddQuantity';
        static ddpRemoveQuantity = 'LiquidBulkStockRecord.Action.DdpRemoveQuantity';
        static universalDdp = 'LiquidBulkStockRecord.Action.UniversalDdp';
        static ddpCustoms = 'LiquidBulkStockRecord.Action.DdpCustoms';
        static ddpChangeUnloading = 'LiquidBulkStockRecord.Action.DdpChangeUnloading';
        static createExitServiceRequest = 'LiquidBulkStockRecord.Action.CreateExitServiceRequest';
    };

}

export class TruckVisitPermissions {
    static _ = 'TruckVisit';

    static View = class {
        static _ = 'TruckVisit.View';

        static all = 'TruckVisit.View.All';
        static own = 'TruckVisit.View.Own';
    };

    static Action = class {
        static _ = 'TruckVisit.Action';

        static cancel = 'TruckVisit.Action.Cancel';
        static delete = 'TruckVisit.Action.Delete';
        static search = 'TruckVisit.Action.Search';
        static create = 'TruckVisit.Action.Create';
        static edit = 'TruckVisit.Action.Edit';
        static block = 'TruckVisit.Action.Block';
        static unblock = 'TruckVisit.Action.Unblock';
        static upload = 'TruckVisit.Action.Upload';
        static update = 'TruckVisit.Action.Update';
        static confirm = 'TruckVisit.Action.Confirm';
        static createStorageDocument = 'TruckVisit.Action.CreateStorageDocument';
        static cancelParkingBill = 'TruckVisit.Action.CancelParkingBill';
        static revert = 'TruckVisit.Action.Revert';
        static createParkingBill = 'TruckVisit.Action.CreateParkingBill';
        static sendEccosMessage = 'TruckVisit.Action.SendEccosMessage';
    };

}

export class VehiclePermitPermissions {
    static _ = 'VehiclePermit';

    static View = class {
        static _ = 'VehiclePermit.View';

        static all = 'VehiclePermit.View.All';
        static own = 'VehiclePermit.View.Own';
    };

    static Action = class {
        static _ = 'VehiclePermit.Action';

        static cancel = 'VehiclePermit.Action.Cancel';
        static search = 'VehiclePermit.Action.Search';
        static create = 'VehiclePermit.Action.Create';
        static edit = 'VehiclePermit.Action.Edit';
    };

}

export class VesselAnnouncementPermissions {
    static _ = 'VesselAnnouncement';

    static View = class {
        static _ = 'VesselAnnouncement.View';

        static all = 'VesselAnnouncement.View.All';
        static own = 'VesselAnnouncement.View.Own';
    };

    static ApprovedPortFacilities = class {
        static approve = 'VesselAnnouncement.Action.ApprovePortFacilities';
    };

    static VesselAnnouncementDocument = class {
        static deklotApproveDecline = 'VesselAnnouncement.Action.DeklotApproveDecline';
        static ispsApproveDecline = 'VesselAnnouncement.Action.IspsApproveDecline';
        static fal3ApproveDecline = 'VesselAnnouncement.Action.Fal3ApproveDecline';
        static fAL2OAddItem = 'VesselAnnouncement.Action.FAL2OAddItem';
        static fAL2DAddItem = 'VesselAnnouncement.Action.FAL2DAddItem';
        static downloadVesselDocument = 'VesselAnnouncement.Action.DownloadVesselDocument';
    };

    static Action = class {
        static _ = 'VesselAnnouncement.Action';

        static cancel = 'VesselAnnouncement.Action.Cancel';
        static search = 'VesselAnnouncement.Action.Search';
        static documentSearch = 'VesselAnnouncement.Action.DocumentSearch';
        static edit = 'VesselAnnouncement.Action.Edit';
        static create = 'VesselAnnouncement.Action.Create';
        static declareFreeEntry = 'VesselAnnouncement.Action.DeclareFreeEntry';
        static inHarbour = 'VesselAnnouncement.Action.InHarbour';
        static ready = 'VesselAnnouncement.Action.Ready';
        static estimateTimeOfDeparture = 'VesselAnnouncement.Action.EstimateTimeOfDeparture';
        static customsApprove = 'VesselAnnouncement.Action.CustomsApprove';
        static operationalProgress = 'VesselAnnouncement.Action.OperationalProgress';
        static customsNotice = 'VesselAnnouncement.Action.CustomsNotice';
        static manipulationStart = 'VesselAnnouncement.Action.ManipulationStart';
        static manipulationEnd = 'VesselAnnouncement.Action.ManipulationEnd';
        static startStandStill = 'VesselAnnouncement.Action.StartStandStill';
        static endStandStill = 'VesselAnnouncement.Action.EndStandStill';
        static permissionToLeave = 'VesselAnnouncement.Action.PermissionToLeave';
        static customsDepartureApprove = 'VesselAnnouncement.Action.CustomsDepartureApprove';
        static depart = 'VesselAnnouncement.Action.Depart';
        static cargoManifest = 'VesselAnnouncement.Action.CargoManifest';
        static addAttachment = 'VesselAnnouncement.Action.AddAttachment';
        static cimisSynchronise = 'VesselAnnouncement.Action.CimisSynchronise';
    };
}

export class WarehouseDocumentPermissions {
    static _ = 'WarehouseDocument';

    static View = class {
        static _ = 'WarehouseDocument.View';

        static all = 'WarehouseDocument.View.All';
        static own = 'WarehouseDocument.View.Own';
    };

    static Action = class {
        static _ = 'WarehouseDocument.Action';

        static cancel = 'WarehouseDocument.Action.Cancel';
        static search = 'WarehouseDocument.Action.Search';
        static edit = 'WarehouseDocument.Action.Edit';
        static create = 'WarehouseDocument.Action.Create';
        static addAttachment = 'WarehouseDocument.Action.AddAttachment';
        static print = 'WarehouseDocument.Action.Print';
        static linkTruckVisit = 'WarehouseDocument.Action.LinkTruckVisit';
    };

}

export class WarehouseDocumentGeneralPermissions {
    static _ = 'WarehouseDocumentGeneral';

    static View = class {
        static _ = 'WarehouseDocumentGeneral.View';

        static all = 'WarehouseDocumentGeneral.View.All';
        static own = 'WarehouseDocumentGeneral.View.Own';
    };

    static Action = class {
        static _ = 'WarehouseDocumentGeneral.Action';

        static cancel = 'WarehouseDocumentGeneral.Action.Cancel';
        static search = 'WarehouseDocumentGeneral.Action.Search';
        static edit = 'WarehouseDocumentGeneral.Action.Edit';
        static create = 'WarehouseDocumentGeneral.Action.Create';
        static addAttachment = 'WarehouseDocumentGeneral.Action.AddAttachment';
    };

}


